export default "__VITE_ASSET__C2ADUSin__"